export default __webpack_public_path__ + "static/media/arrow.b3a679ae.svg";